import React from 'react';
import Classes from 'classnames';

export default function SystemFieldPriorityViewInImport(props) {

    const companyPriorities = gd.session.companies.get(gd.companyId).priorities;

    return (
        <div className={Classes("ui5-pill-22 color-pale","gd-pc-bg-"+props.value)}>{companyPriorities["priority"+props.value.toString()]}</div>


    );
}